<template>
  <div>
    <p>{{ msg }}</p>
    <div id="createRooms">
      <h1>Create new rooms</h1>
      <div>Room name <input type="text" v-model="roomCode" /></div>
      <!-- <div>
        von <input type="date" v-model="Datum.von">
        bis <input type="date" v-model="Datum.bis">
      </div> -->
      <div>Password <input type="text" v-model="password" /></div>
      <div class="buttons">
        <div class="submit pointer" @click="erstellen">ERSTELLEN</div>
        <div class="submit pointer" @click="getRooms">Load rooms</div>
      </div>
      <p>click on the link to copy it!</p>
      <div class="codes" v-for="(p, index) in players" :key="index">
        <div>
          Name:
          <template v-if="p.token">
            {{ p.name }}
          </template>
        </div>
        <input v-if="!p.token" type="text" v-model="players[index].name" />
        <div class="output pointer" @click="kopieren(index)">
          Code:
          <div v-if="p.token">
            {{ textFilter(p.token) }}
          </div>
        </div>
      </div>
      <div class="addPlayer submit pointer" @click="addPlayer">add player</div>
      <!-- <div id="seller" class="orange" @click="kopieren('seller')">
        <p class="BorderBottom">Barq (Player)</p>
        <p>{{ sellerToken }}</p>
      </div> -->
      <div id="buyer" class="blue" @click="kopieren('GM')">
        <p class="BorderBottom">Frabank (Gamemaster)</p>
        <p>{{ textFilter(buyerToken) }}</p>
      </div>
    </div>
    <div v-if="rooms.length > 0">
      <h1>Current rooms</h1>
      <div v-for="raum in rooms" :key="raum.id" class="raumview">
        <div>Name: {{ raum.id }}</div>
        <div>Created on: {{ timeFilter(raum.created) }}</div>
        <div>currentEntry: {{ raum.currentEntry }}</div>
        <div class="delete" @click="deleteRoom(raum.id)">CAUTION! DELETE</div>
        <div
          class="participantsInfo"
          v-for="(p, index) in raum.players"
          :key="index"
        >
          <div>{{ index }} : "{{ p.name }}"</div>

          <div>timeJoined {{ p.joined }}</div>
          <div>reloaded {{ p.reloaded }}</div>

          <div v-if="p.device">
            {{ p.device.osName }} [{{ p.device.osVersion }}] :
            {{ p.device.clientName }} [{{ p.device.clientVersion }}]
          </div>
        </div>
      </div>
    </div>
    <div id="version">v1.1</div>
  </div>
</template>

<script>
import copy from "copy-to-clipboard";
// import * as Vue from "vue";
// import JsonEditor from "vue-json-edit";
// import JsonEditor from "vue-json-editor";

// Vue.use(JsonEditor);

export default {
  name: "Admin",
  components: {
    // JsonEditor,
  },
  data() {
    return {
      roomCode: "",
      password: "",
      // Datum:{
      //   von:'',
      //   bis:''
      // },
      sellerToken: "",
      buyerToken: "",
      pressed: false,
      msg: "",
      url: window.location.origin,
      rooms: {},
      questions: {},
      players: [],
    };
  },
  methods: {
    getScore(participants, index) {
      if (!participants[index]) return "PLAYER DELETED";
      return Math.round(participants[index].score);
    },
    answersGiven(players, index) {
      if (!players[index]) return "PLAYER DELETED";
      let answers = 0;
      for (const p in players) {
        for (const u in players[p]) {
          if (u == "score" || u == "winner" || u == "nameAlt") continue;
          for (const f in players[p][u]) {
            // console.log(f);
            if (f == index) answers++;
          }
        }
      }
      return answers;
    },
    nameAlt(players, index) {
      if (index == "GM") return "";
      if (!players[index]) return "!NO PLAYER FOUND!";
      if (players[index].nameAlt) return players[index].nameAlt;
      return "";
    },
    timeJoined(start, joined) {
      var verstrichen = new Date(new Date(joined) - new Date(start));
      var min = verstrichen.getUTCMinutes();
      var sec = verstrichen.getUTCSeconds();

      return (
        "+" + this.zeroPrefix(min, 2) + "min " + this.zeroPrefix(sec, 2) + "sec"
      );
    },
    zeroPrefix(num, digit) {
      var zero = "";
      for (var i = 0; i < digit; i++) {
        zero += "0";
      }
      return (zero + num).slice(-digit);
    },
    timeFilter(time) {
      return time;
    },
    textFilter(text) {
      return "... " + text.substring(text.length - 20) + " ...";
    },
    addPlayer() {
      this.players.push({ name: "", token: "" });
    },
    kopieren(i) {
      if (i == "GM") {
        copy(this.buyerToken);
        return;
      }
      copy(this.url + "/#/player?token=" + this.players[i].token);
    },
    deleteRoom(id) {
      let obj = {
        searchId: id,
        password: this.password,
      };
      this.$http.post("/deleteRoom", obj).then((res) => {
        console.log(res);
        if (res.status === 200) {
          this.msg = res.data.msg;
          this.getRooms();
        } else {
          this.msg =
            "connection to the server couldn't be established, check your internet connection ...";
        }
      });
    },
    erstellen() {
      // this.sellerToken = "";
      this.buyerToken = "";
      // this.$http.get('/aufgaben').then((res)=>{
      //   console.log(res)
      // })
      // if(this.pressed)return
      // console.log('pressed')
      // this.pressed=true

      // let von = Date.parse(this.Datum.von)
      // let bis = Date.parse(this.Datum.bis)
      // console.log(von)
      // console.log(bis)
      // if(von>bis) return
      // let exp = bis-von
      if (this.roomCode.length < 2) return;

      let obj = {
        roomCode: this.roomCode,
        password: this.password,
        players: this.players,
        // exp:exp/1000
      };
      console.log(obj);
      this.$http.post("/createToken", obj).then((res) => {
        console.log(res);
        if (res.status === 200) {
          this.msg = res.data.msg;
          if (res.data.type == "success") {
            this.players = res.data.players;
            console.log(this.players);

            this.buyerToken =
              this.url + "/#/gamemaster?token=" + res.data.access_token.buyer;
            this.token = res.data.access_token;
          }
        } else {
          this.msg =
            "connection to the server couldn't be established, check your internet connection ...";
        }
      });
      console.log("yip");
      this.getRooms();
    },
    getRooms() {
      this.$http
        .post("/admin_getRooms", { password: this.password })
        .then((res) => {
          console.log(res);
          if (res.status === 200) {
            this.msg = res.data.msg;
            if (res.data.type == "success") {
              this.rooms = res.data.rooms;
            }
          } else {
            this.msg =
              "connection to the server couldn't be established, check your internet connection ...";
          }
        });
    },
    // updateRooms() {
    //   if (confirm("CAUTION! Are you sure you want to update the rooms")) {
    //     console.log("rooms updated");
    //     this.$http
    //       .post("/admin_updateRooms", {
    //         password: this.password,
    //         rooms: this.rooms,
    //       })
    //       .then((res) => {
    //         if (res.status === 200) {
    //           this.msg = res.data.msg;
    //         } else {
    //           this.msg =
    //             "connection to the server couldn't be established, check your internet connection ...";
    //         }
    //       });
    //   }
    // },
    // getQuestions() {
    //   this.$http
    //     .post("/getQuestions", { password: this.password })
    //     .then((res) => {
    //       // console.log(res)
    //       if (res.status === 200) {
    //         this.msg = res.data.msg;
    //         if (res.data.type == "success") {
    //           this.questions = res.data.aufgaben;
    //         }
    //       } else {
    //         this.msg =
    //           "connection to the server couldn't be established, check your internet connection ...";
    //       }
    //     });
    // },
  },
  created() {},
};
</script>

<style scoped>
.participantsInfo {
  border: 1px solid lavender;
  margin: 5px;
  padding: 2px;
}

.participantsInfo > div {
  margin: 2px;
}

* {
  padding-left: 10px;
}

.delete {
  border: 2px solid red;
}

.delete:hover {
  cursor: pointer;
  background: red;
  color: white;
}

.raumview {
  display: flex;
  border: 1px solid;
  margin: 15px;
  flex-direction: column;
  width: 350px;
}

.buttons {
  display: flex;
  justify-content: space-between;
  width: 300px;
}

.submit {
  border: 2px solid #588fd3;
  width: 100px;
  text-align: center;
  line-height: 40px;
  padding-right: 10px;
}

.submit:hover {
  background: black;
  color: white;
}

.pointer:hover {
  cursor: pointer;
}

.output:hover {
  background: red;
}

.codes {
  display: flex;
}

.ButtonMargin {
  margin-left: 10px;
}

.BorderBottom {
  border-bottom: 4px solid white;
}

div#createRooms > div {
  padding: 10px;
}

button {
  padding: 10px;
  margin: 10px;
}

.orange,
.blue {
  color: white;
  font-size: 1.5em;
  word-break: break-all;
}

#seller,
#buyer {
  margin: 10px;
  cursor: pointer;
  max-width: 1000px;
}

.orange {
  background-color: rgb(253, 103, 33);
}

.blue {
  background-color: #1860b9;
}

#version {
  position: fixed;
  right: 0px;
  bottom: 0px;
}

#PlayerButtonHolder {
  max-width: 570px;
  display: flex;
  justify-content: space-around;
}
</style>
